import { 
    TAB_DATA_FIELDS, 
    TAB_DATA_FOR_FILTER_TYPE, 
    TAB_DATA_VALUES 
} from "./constants";

export const getViewTabTitles = ({
    quantities, isTutorUser
}) => {
    if (!quantities) return [];
    const tabs = [
        `(${quantities.general}) General`,
        `(${quantities.past}) Pasados`
    ];
    if (!isTutorUser) 
        tabs.push(
            `(${quantities.draft}) Borrador`,
        );
    tabs.push(`(${quantities.canceled}) Cancelados`);
    if (!isTutorUser) 
        tabs.push(
            `(${quantities.unprocessed}) No Procesados`
        );
    return tabs;
}
export const getTabData = (isTutorUser) => {
    if (isTutorUser) 
        return {
            fields: TAB_DATA_FIELDS.TUTOR,
            values: TAB_DATA_VALUES.TUTOR,
            filterTypes: TAB_DATA_FOR_FILTER_TYPE.TUTOR
        };
    return {
        fields: TAB_DATA_FIELDS.ADMIN,
        values: TAB_DATA_VALUES.ADMIN,
        filterTypes: TAB_DATA_FOR_FILTER_TYPE.ADMIN
    };
}